module.exports = __webpack_public_path__ + "img/collection-weddingRings.9fc0b15.jpg";